import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { UserService } from '../../../shared/services/user.service';
import { GAService } from '../book-claim/services/ga-tags.service';
import { OrbitFormClaimService } from '../book-claim/services/orbit-form-claim.service';

export const orbitErrorInterceptor: HttpInterceptorFn = (req, next) => {
  const gaService = inject(GAService);
  const formService = inject(OrbitFormClaimService);
  const userService = inject(UserService);
  if (req.url.includes('/orbit')) {
    return next(req).pipe(
      catchError((error: any) => {
        const orbitError = error.error;
        createErrorGAEvent(error, orbitError, formService, userService, gaService);
        return throwError(() => error);
      })
    );
  }
  return next(req);
};

function createErrorGAEvent(
  error: any,
  orbitError: any,
  formClaimService: OrbitFormClaimService,
  userService: UserService,
  gaService: GAService
) {
  const claim = formClaimService?.state?.claimData;
  const gaTrack = {
    eventClaims: isManualBooking(formClaimService) ? 'error-no-calendar-no-DSP' : 'booking-error',
    digitalID: userService.userInfo?.['custom:digital_id'],
    customerID: userService.userInfo?.sub,
    planNumber: claim?.bundle?.planNumber,
    productName: `${claim?.bundle?.manufacturer} ${claim?.mandatoryData?.productType}`, // eg Hoover Condenser Dryer
    UnderManufacturerGuarantee: claim?.mandatoryData?.planInWarrantyPeriod ? 'Yes' : 'No',
    claimGroup: 'dgx',
    claimedModelNumber: claim?.mandatoryData?.modelNumber,
    claimedSerialNumber: claim?.mandatoryData?.serialNumber,
    claimedAccountBrand: claim?.mandatoryData?.bookingOEM,
    claimedManufacturer: claim?.bundle?.manufacturer,
    claimedClientName: claim?.bundle?.manufacturer,
    //excessClaimsMessage: claim?.excess?.type ? `${claim?.excess?.type === 'CALLOUT' ? 'CALLOUT' : 'EXCESS'}` : 'NO', -- TODO NO EXCESS YET
    excessClaimsMessage: 'NO',
    claimsLogin: claim?.bundle?.journeyState === 'quickbooking' ? 'quick booking' : 'my account',
    eventCategory: 'claimsRequest-dgx',
    eventAction: 'error-dgx',
    eventLabel: getErrorMessage(error, orbitError),
    step: formClaimService?.currentStep(),
    category: 'claims 2.0',
    event: 'genericGAEvent',
  };
  gaService.sendGATag(gaTrack);
}

function getErrorMessage(error: any, orbitError: any) {
  if (typeof error.error === 'string') return `${error.status} ${error.error}`;
  return `${error.status} Orbit code: ${orbitError?.status}`;
}

function isManualBooking(formClaimService: OrbitFormClaimService) {
  return formClaimService.bookingData()?.manualReferral;
}
